import React from "react";
import { Badge, colors } from "../design/badge";
import { EventTag } from "../models/EventTag";
import { Link } from "../design/link";

interface EventTagBadgeProps {
  link?: boolean;
  eventTagId: string;
  eventTags: EventTag[];
  onClick?: () => void;
}

const EventTagBadge: React.FC<EventTagBadgeProps> = ({
  link,
  eventTagId,
  eventTags,
  onClick,
}) => {
  const info = eventTags.find((type) => type._id === eventTagId);
  const component = (
    <Badge
      color={(info?.color ?? "zinc") as keyof typeof colors}
      onClick={onClick}
    >
      {info?.name ?? eventTagId}
    </Badge>
  );
  return link ? (
    <Link href={`/event-tag/${eventTagId}`}>{component}</Link>
  ) : (
    component
  );
};

export default EventTagBadge;
